import videoTr from "../assets/img/videoTr2.png"
import roadmap from "../assets/img/Roadmap_20260805.webp"
import { SEO } from "../components/SEO"
import { Card } from "../components/card/Card"
import { Entry } from "../components/card/PreviewCard"
import { ComingSoonDialog } from "../components/dialog/ComingSoonDialog"
import { useDialog } from "../context/DialogContext"
import { entries, features, gameplay, zombies } from "../data/entries"
import { Container, Link } from "@mui/material"
import useMediaQuery from "@mui/material/useMediaQuery"
import React, { useEffect, useRef, useState } from "react"
import Lightbox from "yet-another-react-lightbox"
import Zoom from "yet-another-react-lightbox/plugins/zoom"
import "yet-another-react-lightbox/styles.css"
import "./Home.css" // Импортируйте CSS файл для стилей
import { Chart, registerables } from "chart.js"
import Box from "@mui/material/Box"
import { PATHS } from "../constants/paths"
import Typography from "@mui/material/Typography" // Import registerables
Chart.register(...registerables) // Register the necessary chart.js components"

export const Home = () => {
  const [currentTurret, setCurrentTurret] = useState(entries.turrets2[0])
  const [currentCommander, setCurrentCommander] = useState(
    entries.commanders[0],
  )
  const [openDialog, closeDialog] = useDialog()
  const [overlayOpacity, setOverlayOpacity] = useState(0)
  const [selectedBlock, setSelectedBlock] = useState("block1")
  const [lightboxOpen, setLightboxOpen] = useState(false)
  const chartRef = useRef(null)

  const onOpenComingSoonDialog = () => {
    openDialog({
      children: <ComingSoonDialog closeDialog={closeDialog} />,
    })
  }

  const isDownSm = useMediaQuery("(max-width: 600px)")
  const isDownMd = useMediaQuery("(max-width: 900px)")

  const handleScroll = () => {
    const scrollTop = window.scrollY
    const newOpacity = scrollTop > 100 ? 0.9 : 0 // 0.8 для затемнения, 0 для прозрачности
    setOverlayOpacity(newOpacity)

    const fixedBlock = document.getElementById("fixedBlock")
    if (window.scrollY > 100) {
      fixedBlock.classList.add("collapsed")
    } else {
      fixedBlock.classList.remove("collapsed")
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  function hexToRgba(hex, alpha = 1) {
    // Удаляем # из начала строки, если он есть
    hex = hex.replace(/^#/, "")

    // Преобразуем шестнадцатеричный цвет в RGB
    const r = parseInt(hex.substring(0, 2), 16)
    const g = parseInt(hex.substring(2, 4), 16)
    const b = parseInt(hex.substring(4, 6), 16)

    // Возвращаем строку в формате rgba
    return `rgba(${r}, ${g}, ${b}, ${alpha})`
  }

  ///токен
  const imageMap = {
    block1: require("../assets/img/reject_investors.png"),
    block2: require("../assets/img/burn.png"),
    block3: require("../assets/img/staking.png"),
    block4: require("../assets/img/marketplace.png"),
  }
  const titlesToken = {
    block1: "Rejection of Investors",
    block2: "Burning ZTD Tokens",
    block3: "Staking",
    block4: "NFT Marketplace Powered by ZTD",
  }
  const descriptionsToken = {
    block1:
      "Investors and funds have repeatedly approached us with offers to support the project. However, we’ve chosen to stay independent — we’re not looking for outside investors.",
    block2:
      "Burning tokens helps create scarcity by reducing supply, increasing their value both on the market and within Zombie TD.",
    block3:
      "The token staking feature lets users earn extra ZTD tokens, while NFT staking boosts rewards and upgrades the staked NFTs.",
    block4:
      "ZTD is the main currency of Zombie TD, and growing demand ensures its use for all NFT buying and selling on the in-game marketplace.",
  }
  const handleMouseEnter = (block) => {
    // Только на десктопе изменяем выбранный блок
    if (!isDownSm) {
      setSelectedBlock(block)
    }
  }
  const blocks = Object.keys(imageMap)

  useEffect(() => {
    const ctx = chartRef.current.getContext("2d")

    const colors = [
      hexToRgba("#FEDD7C"), // &1
      hexToRgba("#5C1F17"), // &2
      hexToRgba("#EDA428"), // &3
      hexToRgba("#F8D9A7"), // &4
      hexToRgba("#1BC4D4"), // &5
      hexToRgba("#FF6F61"), // &6
      hexToRgba("#FFC97A"), // &6
      hexToRgba("#B9472C"), // &6
      hexToRgba("#34D1CC"), // &6
    ]
    // Создание графика
    const myChart = new Chart(ctx, {
      type: "doughnut",
      data: {
        labels: [
          "Play-to-Earn - 42%           ",
          "Staking Rewards - 10%        ",
          "NFT Holder Airdrop - 12%     ",
          "FCD - 9%                     ",
          "Marketing - 8%               ",
          "Team - 7%                    ",
          "Liquidity - 7%               ",
          "Zealy Quests - 3%",
          "Contests & Giveaways - 2%    ",
        ],
        datasets: [
          {
            label: "%",
            data: [42, 10, 12, 9, 8, 7, 7, 3, 2],
            borderWidth: 1,
            backgroundColor: colors,
            hoverOffset: 40,
            borderColor: "rgba(201, 135, 60, 0.52)", // Добавление цвета границы
            offset: [0, 0, 0, 0, 0, 0, 0, 0, 0], // Выдвигаем первый сегмент (Play to Earn)
          },
        ],
      },
      options: {
        layout: {
          padding: {
            top: isDownSm ? 10 : 20,
            bottom: isDownSm ? 10 : 20,
            right: isDownSm ? 10 : 0,
            left: isDownSm ? 10 : 0,
          },
        },
        plugins: {
          tooltip: {
            callbacks: {
              title: () => "",
              label: function (context) {
                // Получаем оригинальную метку (например "Play-to-Earn - 32%")
                const originalLabel = context.label || ""
                // Удаляем проценты из оригинальной метки
                const labelWithoutPercent = originalLabel.split(" - ")[0]
                // Получаем значение (32, 20 и т.д.)
                const value = context.raw || 0
                // Возвращаем новый формат
                return `${labelWithoutPercent}: ${value}%`
              },
            },
          },
          legend: {
            position: isDownSm ? "bottom" : "right",
            align: isDownSm ? "start" : "center",
            // maxHeight: 400,
            labels: {
              boxWidth: isDownSm ? 20 : 40,
              color: "#cccccc",
              font: {
                family: '"Rajdhani", sans-serif',
                size: isDownSm ? 16 : 18,
              },
              padding: isDownSm ? 10 : 20,
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: isDownSm ? 1 : 2,
      },
    })

    // Устанавливаем активную секцию Play to Earn (индекс 0) с подсказкой
    setTimeout(() => {
      if (myChart) {
        myChart.setActiveElements([
          {
            datasetIndex: 0,
            index: 0, // Индекс секции "Play-to-Earn"
          },
        ])
        myChart.tooltip.setActiveElements(
          [
            {
              datasetIndex: 0,
              index: 0,
            },
          ],
          {
            x: myChart.canvas.width / 2,
            y: myChart.canvas.height / 2,
          },
        )
        myChart.update("none") // Обновляем без анимации
      }
    }, 100)
  }, [])

  return (
    <Box>
      <SEO
        title="Zombie TD | Web3 Tower Defense Game with P2E"
        description="Play Zombie TD - a Web3 Tower Defense Game with NFTs, staking, and Play-to-Earn mechanics. Join now and start earning ZTD tokens!"
        ogTitle="Zombie TD | Play & Earn in Web3 Tower Defense"
        ogDescription="Join the ultimate Web3 Tower Defense game. Collect NFTs, stake tokens, and earn rewards while fighting zombies!"
        ogUrl={PATHS.HOME.PATH}
      />
      <div className="home">
        {!isDownSm && (
          <div className="video-background">
            <video autoPlay muted loop>
              <source
                src={require("../assets/video/Trailer.mp4")}
                type="video/mp4"
              />
            </video>
            <div className="overlay" style={{ opacity: overlayOpacity }}></div>
          </div>
        )}

        <div className="fixed-block" id="fixedBlock">
          <a
            href="https://www.youtube.com/watch?v=9AUE-8rNJK8"
            target="_blank"
            rel="noreferrer"
          >
            {/* eslint-disable-next-line jsx-a11y/alt-text */}
            <img src={videoTr} width="100px"></img>
          </a>
          &nbsp;&nbsp;&nbsp;
          <div className="text-content">
            <span className="primary">
              Zombie Tower Defence
              <p className="sub-title">
                <Link
                  className="primary"
                  href={"https://www.youtube.com/watch?v=9AUE-8rNJK8"}
                  target={"_blank"}
                  sx={{
                    textTransform: "uppercase",
                  }}
                >
                  Watch Trailer
                </Link>
              </p>
            </span>
          </div>
        </div>

        <section className="hero">
          <Container fixed={isDownMd && false}>
            <div className="info">
              <h1 className="title">
                Welcome to <span className="primaryColor">Zombie TD</span>
              </h1>
              <p className="sub-title">
                Web3 tower defense in a post-apocalyptic world
                <br />
                <br />
                <span className="primary"> Play. Survive. Earn.</span>
              </p>
            </div>
          </Container>
        </section>

        <section className="intro">
          <Container fixed={isDownMd && false}>
            <div className="head">
              <h2 className="heading">
                <span className="primary">Best Web3 Tower Defense Game</span>
              </h2>
              <p className="subheading">
                Zombie TD is a post-apocalyptic browser-based tower defense game
                built on the Binance Smart Chain. Fight off waves of mutant
                zombies, defend your base, compete with other players, and earn
                ZTD tokens - all directly in your browser on PC, tablet, or
                mobile. The game consists of:
              </p>
            </div>

            <div className="body">
              <div className="list">
                {features.map((feature, index) => (
                  <Card
                    key={index}
                    image={feature.image}
                    subTitle={feature.subtitle}
                  />
                  // Fight for ZTD token!
                ))}
              </div>
              {/*<GetAppsDialog label='Play & Earn'/>*/}
            </div>
          </Container>
        </section>

        <section
          className="features"
          style={{
            backgroundSize: "contain", // Для заполнения блока
            backgroundPosition: "center", // Центрирование изображения
          }}
        >
          <Container fixed={isDownMd && false}>
            <h2 className="heading">
              Token <span className="primary">Stabilization:</span>
            </h2>
            <div style={{ display: "flex" }}>
              <div style={{ flex: 1, padding: "10px" }}>
                {blocks.map((block) => (
                  <div
                    key={block}
                    onMouseEnter={() => handleMouseEnter(block)}
                    className={`item ${selectedBlock === block ? "active" : ""}`}
                    style={{
                      flex: 1,
                      padding: "10px",
                      // На мобильной версии все блоки непрозрачные, на десктопе - эффект выборки
                      opacity: isDownSm ? 1 : selectedBlock === block ? 1 : 0.5,
                      transition: "opacity 0.3s ease",
                    }}
                  >
                    <h4>{titlesToken[block]}</h4>
                    <p>{descriptionsToken[block]}</p>
                  </div>
                ))}
              </div>
              {!isDownSm && (
                <div style={{ flex: 1, padding: "10px" }}>
                  {selectedBlock && (
                    <img
                      src={imageMap[selectedBlock]}
                      alt="Изображение"
                      style={{ width: "100%", height: "100%" }}
                    />
                  )}
                </div>
              )}
            </div>
          </Container>
        </section>

        <Box>
          <section className="entity commanders">
            <Container fixed={isDownMd && false}>
              <div className="head">
                <h2 className="heading">
                  <span className="primary">Commanders</span>
                </h2>
                <p className="subheading">
                  NFT Commanders play an essential role in Zombie TD. There is a{" "}
                  <span className="primary">Base Commander NFT</span> (which is
                  provided for free) and a{" "}
                  <span className="primary">Specialized Commander NFT</span>{" "}
                  (which can be purchased on the Marketplace or NFT Boxes sale).
                  Specialized Commanders have a specialization for one of the
                  five Turrets, which increases the attack, damage radius, and
                  ability effectiveness of one of the five Turrets:
                </p>
              </div>

              <div className="body">
                <div className="media">
                  <video
                    src={currentCommander.video}
                    poster={currentCommander.image}
                    preload="auto"
                    muted
                    autoPlay={true}
                    loop
                    className="videoContainer"
                  />
                </div>
                <div className="info">
                  <div className="head">
                    <Typography variant="h4" sx={{fontSize: { xs: "0.5rem !important", sm: "20px !important" }}}>
                      {currentCommander.title}
                    </Typography>
                    <p>{currentCommander.description}</p>
                  </div>
                  <div className="body">
                    <div className="list">
                      {Object.entries(entries.commanders).map(
                        ([key, value], index) => {
                          return (
                            <Entry
                              key={index}
                              turrets={entries.commanders}
                              image={value.image}
                              setCurrentTurret={setCurrentCommander}
                              index={index}
                            />
                          )
                        },
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Container>
          </section>
        </Box>

        <Box mt={{xs: 4, sm: 0}}>
          <section className="entity commanders light">
            <Container fixed={isDownMd && false}>
              <div className="head">
                <h2 className="heading">
                  <span className="primary">Turrets</span>
                </h2>
                <p className="subheading">
                  NFT Turrets are the only way to defend against zombies. All
                  Turrets have their characteristics and unique abilities.
                </p>
              </div>

              <div className="body">
                {isDownSm && (
                  <div className="media">
                    <video
                      src={currentTurret.video}
                      poster={currentTurret.image}
                      preload="auto"
                      muted
                      autoPlay={true}
                      loop
                      className="videoContainer"
                    />
                  </div>
                )}

                <div className="info">
                  <div className="head">
                    <Typography variant="h4" sx={{fontSize: { xs: "0.5rem !important", sm: "20px !important" }}}>
                      {currentTurret.title}
                    </Typography>
                    <p>{currentTurret.description}</p>
                  </div>
                  <div className="body">
                    <div className="list">
                      {Object.entries(entries.turrets2).map(
                        ([key, value], index) => {
                          return (
                            <Entry
                              key={index}
                              index={index}
                              turrets={entries.turrets2}
                              image={value.image}
                              setCurrentTurret={setCurrentTurret}
                            />
                          )
                        },
                      )}
                    </div>
                  </div>
                </div>

                {!isDownSm && (
                  <div className="media">
                    <video
                      src={currentTurret.video}
                      poster={currentTurret.image}
                      preload="auto"
                      muted
                      autoPlay={true}
                      loop
                      className="videoContainer"
                    />
                  </div>
                )}
              </div>
            </Container>
          </section>
        </Box>

        <Box mt={{xs: 6, sm: 0}}>
        <section className="entity zombies">
          <Container fixed={isDownMd && false}>
            <div className="head">
              <h2 className="heading">
                <span className="primary">Zombies</span>
              </h2>
              <p className="subheading">
                Due to an incident in the laboratory of the 'Zero Time Day'
                corporation, a virus that causes mutations in all living beings
                broke out and spread around the world with great speed. As a
                result, the virus-infected many living beings who became the
                living dead.
              </p>
            </div>

            <div className="body">
              <div className="list">
                {zombies.map((zombie) => (
                  <div className="item">
                    <div className="media">
                      <img src={zombie.image} alt={zombie.alt} />
                    </div>
                    <div className="content">
                      <h4>{zombie.title}</h4>
                    </div>
                  </div>
                ))}
                <div className="item"></div>
              </div>
            </div>
          </Container>
        </section>
        </Box>

        <Box mt={{xs: 4, sm: 0}}>
        <section className="intro">
          <Container fixed={isDownMd && false}>
            <div className="head" style={{ marginBottom: isDownSm ? 0 : "20px"}}>
              <h2 className="heading">
                <span className="primary">Earn money</span> by playing Zombie TD
              </h2>
              <p className="subheading">
                There are various ways to earn money in the game, the main ones
                are:
              </p>
            </div>

            <div className="body">
              <div className="list">
                {gameplay.map((advantage) => (
                  <Card
                    image={advantage.image}
                    title={advantage.title}
                    subTitle={advantage.description}
                  />
                ))}
              </div>
              {/*<GetAppsDialog label='Play & Earn'/>*/}
            </div>
          </Container>
        </section>
        </Box>

        <Box mt={{xs: 2, sm: 0}}>
        <section className="tokenomics">
          <Container fixed={isDownMd && false}>
            <div className="head">
              <h2 className="heading">
                <span className="primary">Tokenomics</span>
              </h2>
              <p className="subheading">
                The ZTD token has a maximum supply of 1,000,000,000 tokens, and
                is (or will be) distributed as follows:
              </p>
            </div>
            <center>
              <div
                style={{
                  maxWidth: isDownSm ? "100%" : "900px",
                  height: isDownSm ? "640px" : "500px",
                  width: isDownSm ? "100%" : "auto",
                }}
              >
                <canvas ref={chartRef} id="myChart"></canvas>
              </div>
            </center>
          </Container>
        </section>
        </Box>

        <Box mt={{xs: 1, sm: 0}}>
        <section>
          <Container fixed={isDownMd && false}>
            <div className="head">
              <h2 className="heading">
                <span className="primary">Roadmap</span>
              </h2>
            </div>
            <div className="body">
              {isDownSm ? (
                <img
                  src={roadmap}
                  alt="Roadmap"
                  onClick={() => setLightboxOpen(true)}
                  style={{ cursor: "pointer" }}
                />
              ) : (
                <img src={roadmap} alt="Roadmap" />
              )}
            </div>
          </Container>
        </section>
        </Box>

        {isDownSm && (
          <Lightbox
            open={lightboxOpen}
            close={() => setLightboxOpen(false)}
            slides={[
              {
                src: roadmap,
                alt: "Roadmap",
              },
            ]}
            plugins={[Zoom]}
            zoom={{
              zoomInMultiplier: 2,
              doubleTapDelay: 300,
              doubleClickDelay: 300,
              doubleClickMaxStops: 2,
              keyboardMoveDistance: 50,
              wheelZoomDistanceFactor: 100,
              pinchZoomDistanceFactor: 100,
              scrollToZoom: true,
            }}
            on={{
              view: ({ index }) => {
                // Устанавливаем зум в 100% при открытии изображения
                setTimeout(() => {
                  const zoomButton = document.querySelector(
                    '[aria-label="Zoom in"]',
                  )
                  if (zoomButton) {
                    // Сброс к исходному размеру и установка 100%
                    const resetButton = document.querySelector(
                      '[aria-label="Reset zoom"]',
                    )
                    if (resetButton) resetButton.click()

                    // Затем устанавливаем 100% zoom
                    zoomButton.click()
                    zoomButton.click()
                  }
                }, 100)
              },
            }}
            render={{
              buttonPrev: () => null,
              buttonNext: () => null,
              iconPrev: () => null,
              iconNext: () => null,
            }}
          />
        )}
      </div>
    </Box>
  )
}
